import React, { useState } from "react";
import selectArrowIcon from '../../img/icons/select-arrow.svg';
import './style.scss';
import { Project } from "../../redux/types/Project";

interface SelectPickerProps {
    options: Project[];
    onOptionSelect: (value: string) => void;
}

const SelectPicker: React.FC<SelectPickerProps> = ({ options, onOptionSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(options[0]?.title);

    const toggleDropdown = () => setIsOpen(!isOpen);
    const handleOptionClick = (project: Project) => {
        setSelectedOption(project.title);
        setIsOpen(false);
        onOptionSelect(project.id);
    };
    
    return (
        <div className={`custom-select-picker ${isOpen ? 'open' : ''}`}>
            { options.length > 1 && ( <img src={selectArrowIcon} alt="V" className="custom-select-picker_icon" onClick={toggleDropdown} />) }
            <div className="selected-option" onClick={toggleDropdown}>
                {selectedOption}
            </div>
            <div className={`options ${isOpen ? 'open' : ''}`}>
                {options.map(option => (
                    <div key={option.id} className="option" onClick={() => handleOptionClick(option)}>
                        {option.title}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SelectPicker;